import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Do Good Candle Studio — Reorder campaign (adc_g9mj2jrasg). RUNNING since
// Jun 25, 2026 and it has never spent a cent: 83 impressions across its three
// complete months, no clicks, no conversions, no sales.
//
// That is the real state, not missing data — it is the only campaign in this set
// that is switched on and has produced literally nothing, which is what makes it
// worth having. The $468 reorder this brand has seen was booked by the
// new-customer campaign in Sep 2024, well before this one existed, so it counts
// as continued sales from an ads-acquired customer rather than a reorder
// conversion here.
export const campDgcReorder: FaireAdCampaignEntity = {
  token: "camp_dgc_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_do_good_candle",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 100,
  startedRunningAt: "2026-06-25",
  segmentMetrics: {
    numReorderConversions: 0,
    salesDollars: 0,
    totalAdsSpendDollars: 0,
    returnOnAdSpend: 0,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-21T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
